<template>
  <div class='referral-chain-container'>
    <div class="title">{{ $t(`${i18nPrefix}.label.baseInfo`) }}</div>
    <div class="content">
      <div class="job-info-content">
        <div v-if="!fromJobPotential" class="job-select-content">
          <span class="job-title">{{ $t(`${i18nPrefix}.label.jobs`) }}</span>
          <el-tooltip
            effect="light"
            popper-class="light-tooltip-popper"
            placement="bottom-start"
            :content="formatJobInfo(selectJobId, jobList)"
          >
            <el-select v-model="selectJobId" class="job-selector" :class="jobList.length > 1 ? '' : 'is-one-job'" :disabled="jobList.length === 1" @change="handelJobChange">
              <el-option
                v-for="(job, index) in jobList"
                :key="index"
                :label="job.i18nName"
                :value="job.id"
              ></el-option>
            </el-select>
          </el-tooltip>
        </div>
        <div class="referral-info-content">
          <div class="referral-title">{{ $t(`${i18nPrefix}.label.referralInfo`) }}</div>
          <div v-if="referralInfo.referral_chain_id" class="referral-info">
            <div class="is-employee">
              <span v-if="referralInfo.is_employee">{{ $t(`${i18nPrefix}.label.employee`) }}</span>
              <span v-else>{{ $t(`${i18nPrefix}.label.noEmployee`) }}</span>
            </div>
            <div class="mobile">{{ $t(`${i18nPrefix}.label.referralMobile`) }} {{ referralInfo.mobile }}</div>
            <div class="email">{{ $t(`${i18nPrefix}.label.referralEmail`) }}
              <el-tooltip
                effect="light"
                popper-class="light-tooltip-popper"
                placement="bottom"
                :content="referralInfo.email"
              >
                <span>{{ referralInfo.email }}</span>
              </el-tooltip>
            </div>
            <div class="name">{{ $t(`${i18nPrefix}.label.referralName`) }}
              <el-tooltip
                effect="light"
                popper-class="light-tooltip-popper"
                placement="bottom"
                :content="referralInfo.name"
              >
                <span>{{ referralInfo.name }}</span>
              </el-tooltip>
            </div>
            <!-- <div class="referral_reason">{{ $t(`${i18nPrefix}.label.referralReason`) }} {{ referralInfo.referral_reason }}</div> -->
          </div>
          <div v-else class="no-data">{{ $t('common.label.noData') }}</div>
        </div>
      </div>
      <div class="referral-chain">
        <div class="referral-chain-title">{{ $t('admin.application.applicantList.label.referralChain') }}</div>
        <ReferralChain v-if="referralChainInfo.length" class="chain-item" :referralChainInfo="referralChainInfo"/>
        <div v-else class="no-data">{{ $t('common.label.noData') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import ReferralChain from './components/referralChain.vue'

export default {
  components: {
    ReferralChain
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      selectJobId: null,
      jobList: [],
      referralChainInfo: [],
      referralInfo: {}
    }
  },
  computed: {
    jobId () {
      return this.$route.params.jobId
    },
    fromJobPotential () {
      if (this.$route.params.jobId) {
        return true
      } else {
        return false
      }
    },
    candidateId () {
      return this.$route.query.candidate_id
    },
    potentialId () {
      return this.$route.params.potentialId
    }
  },
  created () {
    this.loadCandidateReferralChain()
  },
  methods: {
    ...mapActions('potential', ['getCandidateReferralChain']),
    async loadCandidateReferralChain () {
      const params = {
        candidate_id: this.candidateId
      }
      if (this.fromJobPotential) {
        params.job_id = this.jobId
      }
      const resp = await this.getCandidateReferralChain(params)
      if (resp) {
        this.jobList = _.map(resp.job_info_list, job => {
          addI18nProperty(job, 'i18nName', 'cn_name', 'en_name')
          return job
        })
        this.selectJobId = resp.job_info_list.length ? this.jobList[0].id : null
        _.reverse(resp.referral_chain)
        this.referralChainInfo = resp.referral_chain
        this.referralInfo = resp.referral_info
      }
    },
    async handelJobChange () {
      if (!this.selectJobId) {
        return
      }
      const params = {
        candidate_id: this.candidateId,
        job_id: this.selectJobId
      }
      const resp = await this.getCandidateReferralChain(params)
      if (resp) {
        _.reverse(resp.referral_chain)
        this.referralChainInfo = resp.referral_chain
        this.referralInfo = resp.referral_info
      }
    },
    formatJobInfo (selectedJobId, jobList) {
      const selectedJob = _.find(jobList, job => job.id === selectedJobId)
      return selectedJob?.i18nName
    }
  }
}
</script>
<style lang='scss' scoped>
.referral-chain-container {
  margin: 40px 300px 160px;

  .title {
    font-size: 18px;
    color: #303133;
    font-weight: bold;
  }

  .content {
    padding: 40px 140px 100px;
    margin-top: 30px;
    border: 1px solid #e4e7ed;
    display: flex;

    .job-info-content {
      flex: 1;
      margin-right: 80px;
      overflow-x: auto;
      .job-select-content {
        margin-bottom: 10px;
        .job-title {
          margin-bottom: 4px;
          font-weight: bold;
          display: block;
        }

        .job-selector {
          ::v-deep .el-input__inner {
            border: 0;
            background-color: transparent;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 82%;
            padding: 0px;
          }
        }

        .is-one-job {
          ::v-deep {
            .el-input__inner {
              color: #232323;
              cursor: text;
              padding: 0;
            }
            .el-input__suffix {
              display: none;
            }
          }
        }
      }

      .referral-info-content {
        .referral-title {
          margin-bottom: 4px;
          font-weight: bold;
        }

        .referral-info {
          .mobile {
            overflow: hidden;
            max-width: 245px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .email {
            overflow: hidden;
            max-width: 245px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .name {
            overflow: hidden;
            max-width: 245px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .no-data {
          line-height: 32px;
        }
      }
    }

    .referral-chain {
      flex: 1;
      max-width: 330px;
      overflow: auto;
      .referral-chain-title {
        padding-left: 10px;
        margin-bottom: 4px;
        font-weight: bold;
      }

      .chain-item {
        ::v-deep .avatar {
          width: 80px;
          height: 80px;
        }
      }

      .no-data {
        margin-left: 10px;
        line-height: 32px;
      }
    }

  }
}
</style>
